import { QueryConfig } from '@helo/cms'

import { useAppStore } from '../../../store/appStore/appStore'
import { TableProbeQueryContext } from './tableProbeQueryContext.types'

const createAppStoreTableProbeQueryContext = (): TableProbeQueryContext => {
  const { queryStore } = useAppStore.getState()

  return {
    registerQuery: (config: QueryConfig) => {
      queryStore.registerQuery(config)
    },
    removeQuery: (queryId: string) => {
      queryStore.removeQuery(queryId)
    },
    updateVariablesAndRefetch: async (queryId, variables) => {
      await queryStore.updateVariables(queryId, variables)
      return queryStore.refetchQuery(queryId)
    },
  }
}

export const AppStoreTableProbeQueryContext = {
  create: createAppStoreTableProbeQueryContext,
}
